import { type FC, type PropsWithChildren } from 'react';

import { Action } from '@soluto-private/mx-asurion-ui-react';

import {
  doNotSellMyPersonalInfo,
  privacyPolicyUrl,
  termsOfServiceUrl,
  termsOfUseUrl,
} from './urls';

export type LegalLinkDetails = PropsWithChildren<unknown>;

export const TermsOfServiceLink: FC<LegalLinkDetails> = ({ children }) => {
  return (
    <Action
      color="secondary"
      data-testid="terms-of-service"
      href={termsOfServiceUrl}
      target="_blank"
      variant="flat"
    >
      {children}
    </Action>
  );
};

export const TermsOfUseLink: FC<LegalLinkDetails> = ({ children }) => {
  return (
    <Action
      color="secondary"
      data-testid="terms-of-use"
      href={termsOfUseUrl}
      target="_blank"
      variant="flat"
    >
      {children}
    </Action>
  );
};

export const PrivacyPolicyLink: FC<LegalLinkDetails> = ({ children }) => {
  return (
    <Action
      color="secondary"
      data-testid="privacy-policy"
      href={privacyPolicyUrl}
      target="_blank"
      variant="flat"
    >
      {children}
    </Action>
  );
};

export const DoNotSellPersonalInfoLink: FC<LegalLinkDetails> = ({
  children,
}) => {
  return (
    <Action
      color="secondary"
      data-testid="do-not-sell-my-personal-info"
      href={doNotSellMyPersonalInfo}
      target="_blank"
    >
      {children}
    </Action>
  );
};
